module.exports = __webpack_public_path__ + "img/MX.c626f837.svg";